import {Component, OnInit} from '@angular/core';
import {map} from 'rxjs/operators';
import {WIZARD_ROUTES} from '../wizard-routes';
import {ActivatedRoute, Router} from '@angular/router';
import {EnvironmentService} from '../../../core/services/environment.service';

@Component({
  templateUrl: './no-action-page.component.html',
})
export class NoActionPageComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private environmentService: EnvironmentService) {
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.pipe(
      map(() => window.history.state)
    ).subscribe((state: any) => {
      if (state.jtp == null) {
        this.navigateToStart();
        return;
      }
    });
  }

  private navigateToStart(): void {
    this.router.navigate([WIZARD_ROUTES.UPLOAD_PAGE]).then(/* DO NOTHING */);
  }

  onWorkshopSearch(): void {
    document.location.href = this.environmentService.workshopSearchEndpoint;
  }
}
